import {
    RaikoButtonPrimary,
    RaikoDatePicker,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoMoneyInputOutlined,
    RaikoNumberInputOutlined,
    RaikoToggleOutlined, showErrorMessage, showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {numberIsEmpty, numberIsNotBiggerThanZero, stringIsEmpty} from "../../util/VariableChecker";
import {FundService} from "../../serverService/fund/FundService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function AddNewFund({handleAddNewItemToTable}) {

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [fundName, setFundName] = useState("")
    const [groupCount, setGroupCount] = useState("");
    const [dayOfMeeting, setDayOfMeeting] = useState("")
    const [fixedFeeRate, setFixedFeeRate] = useState("");
    const [startDate, setStartDate] = useState("");
    const [minimumAmount, setMinimumAmount] = useState("");
    const [lastDayForPay, setLastDayForPay] = useState("");
    const [address, setAddress] = useState("");
    const [status, setStatus] = useState(true)

    function handleAddNewFund() {
        if (checkFields()) {
            loading.show()
            service.createNewFund(
                fundName,
                groupCount,
                dayOfMeeting,
                fixedFeeRate,
                startDate,
                minimumAmount,
                lastDayForPay,
                address,
                status
            ).then(response => {
                showSuccessMessage("صندوق جدید با موفقیت افزوده شد.")
                handleAddNewItemToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(fundName)) {
            message = "لطفا نام صندوق را وارد نمایید."
        } else if (numberIsNotBiggerThanZero(groupCount)) {
            message = "لطفا حداکثر تعداد گروه را وارد نمایید."
        } else if (numberIsNotBiggerThanZero(dayOfMeeting)) {
            message = "لطفا تاریخ روز جلسات ماهیانه را وارد نمایید."
        } else if (numberIsEmpty(fixedFeeRate)) {
            message = "لطفا نرخ کارمزد ثابت را وارد نمایید."
        } else if (!startDate || startDate.length !== 10) {
            message = "لطفا تاریخ شروع فعالیت را وارد نمایید."
        } else if (numberIsEmpty(minimumAmount)) {
            message = "لطفا حداقل مبلغ واریز پس انداز را وارد نمایید."
        } else if (numberIsEmpty(lastDayForPay)) {
            message = "لطفا آخرین روز مجاز واریز را وارد نمایید."
        } else if (stringIsEmpty(address)) {
            message = "لطفا آدرس صندوق را وارد نمایید."
        } else
            state = true


        if (message)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridTwoColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"نام صندوق"} value={fundName} setValue={setFundName}/>
                <RaikoNumberInputOutlined
                    labelText={"حداکثر تعداد گروه"} value={groupCount} setValue={setGroupCount}/>
                <RaikoNumberInputOutlined
                    labelText={"تاریخ روز جلسات ماهانه"} value={dayOfMeeting}
                    setValue={value => {
                        if (!value || parseInt(value) < 32) {
                            setDayOfMeeting(value)
                        }
                    }}/>
                <RaikoNumberInputOutlined
                    labelText={"نرخ کارمزد ثابت (درصد)"}
                    value={fixedFeeRate}
                    setValue={value => {
                        if (!value || parseInt(value) <= 100) {
                            setFixedFeeRate(value)
                        }
                    }}/>
                <RaikoDatePicker label={"تاریخ شروع فعالیت"} date={startDate} setDate={setStartDate}/>
                <RaikoMoneyInputOutlined
                    labelText={"حداقل مبلغ واریز پس انداز (ریال)"} value={minimumAmount}
                    setValue={setMinimumAmount}/>
                <RaikoNumberInputOutlined
                    labelText={"تاریخ آخرین روز مجاز واریز"}
                    value={lastDayForPay}
                    setValue={value => {
                        if (!value || parseInt(value) < 32) {
                            setLastDayForPay(value)
                        }
                    }}/>
                <RaikoToggleOutlined checked={status} setChecked={setStatus} labelText={"وضعیت"}/>
            </RaikoGridTwoColumn>

            <RaikoMaterialOutlinedInput labelText={"آدرس"} value={address} setValue={setAddress}/>

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleAddNewFund}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}